// extracted by mini-css-extract-plugin
export var banner = "_3o-0";
export var icon = "_3o-1";
export var message = "_3o-2";